import React from 'react'
import { ModalSeeker } from '@ui-seeker/core'
import { Table, TableBody, TableCell, TableHead, TableRow, Skeleton, Typography, Box } from '@mui/material'
import { scraperSiteSelected } from 'Pages/Admin/GlobalExecution/@signals'
import { useScraperUserSearches } from './@hooks'

export default function ScraperUserSearchesModal() {
	const { data, isLoading, siteName, onClose } = useScraperUserSearches()

	return <ModalSeeker
		title={`Searches per user — ${siteName}`}
		isOpen={scraperSiteSelected.value !== null}
		controller={onClose}
		hideActions
	>
		{isLoading
			? <Skeleton variant="rectangular" height={200} />
			: data.length === 0
				? <Typography color="text.secondary" textAlign="center" py={2}>No data</Typography>
				: <Box sx={{ overflowX: 'auto' }}>
					<Table size="small" sx={{ '& .MuiTableCell-root': { color: 'text.primary' } }}>
						<TableHead>
							<TableRow>
								<TableCell sx={{ fontWeight: 'bold' }}>User</TableCell>
								<TableCell sx={{ fontWeight: 'bold' }} align="right">Searches</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{data.map((row, i) => (
								<TableRow key={i} hover>
									<TableCell>{row.userName}</TableCell>
									<TableCell align="right">{row.searches}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</Box>
		}
	</ModalSeeker>
}